export default {
  platform: {
    title: "平台设置",
    name: "平台标题",
    namePh: "请输入平台标题",
    platformId: "平台ID",
    logo: "平台logo",
    contact: "平台联系方式",
    contactPh: "请输入联系方式",
    txKey: "请输入腾讯地图key",
    txKeyPh: "请输入腾讯地图key",
    intro: "平台简介",
    introPh: "请输入平台简介",
    regAgreement: "注册协议",
    management: "管理规定",
    aboutUs: "关于我们",
  },
  agreement: {
    title: "协议规则",
    platformRule: "平台规则",
    riderRule: "骑手规则",
    add: "添加协议",
    ruleTitle: "规则标题",
    ruleDetail: "规则详情",
    ruleSort: "规则排序",
    ruleSortPh: "请输入规则排序",
    ruleTitlePh: "请输入规则标题",
  },
  ad: {
    title: "广告列表",
    add: "添加广告",
    edit: "编辑",
    sort: "广告排序",
    sortPh: "请输入广告排序",
    name: "广告标题",
    namePh: "请输入广告标题",
    image: "广告图片",
    displayStatus: "显示状态",
    enableStatus: "启用状态",
    show: "显示",
    hide: "隐藏",
    enable: "开启",
    disable: "禁用",
  },
  notice: {
    title: "公告列表",
    add: "添加公告",
    noticeTitle: "公告标题",
  },
  message: {
    title: "消息通知",
    add: "新增通知",
  },
  sms: {
    title: "短信设置",
    aliyunSms: "阿里云短信",
    accessKeyIdPh: "请输入access_key_id",
    accessKeySecretPh: "请输入access_key_secret",
    templateSign: "模板签名",
    templateSignPh: "请输入模板签名",
    testPhone: "接收测试手机号",
    testPhonePh: "请输入接收测试手机号",
    verifyCodeTemplateTitle: "短信验证码模板ID设置",
    accountRegister: "账号注册",
    changePassword: "修改密码",
    templateIdPh: "请输入模板ID",
    sendTest: "发送测试",
  },
  payment: {
    title: "微信支付设置",
    normalMchId: "普通支付商户号",
    normalMchIdPh: "请输入普通支付商户号",
    normalMchKey: "普通支付商户密钥",
    normalMchKeyPh: "请输入普通支付商户密钥",
    certPem: "普通支付证书apiclient_cert.pem",
    keyPem: "普通支付证书apiclient_key.pem",
    certPh: "请输入服务商证书",
    uploaded: "已上传",
    certTip: "使用文本编辑器打开apiclient_cert.pem文件，将文件的内容全部复制进来",
    keyTip: "使用文本编辑器打开apiclient_key.pem文件，将文件的内容全部复制进来",
  },
  storage: {
    title: "远程附件",
    localStorage: "本地存储",
    qiniu: "七牛云存储",
    aliyun: "阿里云OSS",
    tencent: "腾讯云存储",
    qiniuNotice: "启用七牛云存储后，请把/attachment目录（不包括此目录）下的子文件及子目录上传至七牛云存储, 相关工具： 七牛云存储",
    aliyunNotice: "启用阿里oss后，请把/attachment目录（不包括此目录）下的子文件及子目录上传至阿里云oss, 相关工具：",
    tencentNotice: "启用腾讯云cos对象存储后，请把/attachment目录（不包括此目录）下的子文件及子目录上传至腾讯云存储, 相关工具：腾讯云存储",
    accesskey: "Accesskey",
    accesskeyPh: "请输入Accesskey",
    accesskeyRemark: "用于签名的公钥",
    secretkey: "Secretkey",
    secretkeyPh: "请输入Secretkey",
    secretkeyRemark: "用于签名的私钥",
    bucket: "Bucket",
    bucketPh: "请输入Bucket",
    bucketRemark: "请保证bucket为可公共读取的",
    bucketRegion: "Bucket所在区域",
    selectRegion: "请选择所在区域",
    url: "Url",
    urlPh: "请输入Url",
    qiniuUrlRemark: "七牛支持用户自定义访问域名。注：url开头加http://或https://结尾不加 '/'例：http://abc.co",
    accessKeyId: "Access Key ID",
    accessKeyIdPh: "请输入Access Key ID",
    accessKeyIdRemark: "Access Key ID是您访问阿里云API的密钥，具有该账户完全的权限，请您妥善保管。",
    accessKeySecret: "Access Key Secret",
    accessKeySecretPh: "请输入Access Key Secret",
    accessKeySecretRemark: "Access Key Secret是您访问阿里云API的密钥，具有该账户完全的权限，请您妥善保管。(填写完Access Key ID 和 Access Key Secret 后请选择bucket)",
    endpointSelect: "Endpoint选择",
    endpointSelectPh: "Endpoint选择",
    endpointRemark: "完善Access Key ID和Access Key Secret资料后可以选择存在的Bucket(请保证bucket为可公共读取的)，否则请手动输入。",
    bucketSelect: "Bucket选择",
    bucketSelectPh: "bucket选择",
    customUrl: "自定义URL",
    customUrlPh: "请输入自定义URL",
    aliyunUrlRemark: "阿里云oss支持用户自定义访问域名，如果自定义了URL则用自定义的URL，如果未自定义，则用系统生成出来的URL。注：自定义url开头加http://或https://结尾不加 '/'例：http://abc.com",
    appId: "APPID",
    appIdPh: "请输入Accesskey",
    appIdRemark: "APPID 是您项目的唯一ID",
    secretId: "SecretID",
    secretIdPh: "请输入Secretkey",
    secretIdRemark: "SecretID 是您项目的安全密钥，具有该账户完全的权限，请妥善保管",
    secretKey: "SecretKEY",
    secretKeyPh: "请输入Bucket",
    secretKeyRemark: "SecretKEY 是您项目的安全密钥，具有该账户完全的权限，请妥善保管",
    tencentBucketPh: "请输入Url",
    tencentRegionRemark: "选择bucket对应的区域，如果没有选择无",
    tencentUrlRemark: "腾讯云支持用户自定义访问域名。注：url开头加http://或https://结尾不加 '/'例：http://abc.com",
    regionEastChina: "华东",
    regionNorthChina: "华北",
    regionSouthChina: "华南",
    regionNorthAmerica: "北美",
    regionHangzhou: "华东1（杭州）",
    regionShanghai: "华东2（上海）",
    regionQingdao: "华北1（青岛）",
    regionBeijing: "华北2（北京）",
    regionZhangjiakou: "华北3（张家口）",
    regionHohhot: "华北5（呼和浩特）",
    regionShenzhen: "华南1（深圳）",
    regionHongKong: "中国香港",
    regionChengdu: "西南1（成都）",
    regionBeijingShort: "北京",
    regionNanjing: "南京",
    regionShanghaiShort: "上海",
    regionGuangzhou: "广州",
    regionChengduShort: "成都",
    regionChongqing: "重庆",
  },
  idRecognition: {
    title: "身份证识别设置",
    appIdPh: "请输入APP ID",
    apiKeyPh: "请输入API KEY",
    secretKeyPh: "请输入SECRET KEY",
  },
  versionUpdate: {
    title: "版本更新",
    version: "版本号",
    versionPh: "请输入最新版本号，如 1.0.1",
    downloadUrl: "下载地址",
    downloadUrlPh: "请输入App下载地址",
    forceUpdate: "强制更新",
    content: "更新内容",
    contentPh: "请输入更新说明",
  },
};
